// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v2-landing {
  --v2-bg: #0b0b0c;
  --v2-bg-alt: #141416;
  --v2-cream: #f4efe6;
  --v2-muted: #b7b0a6;
  --v2-muted-2: #7e7a70;
  --v2-green: #2f6a4a;
  --v2-green-light: #6fa886;
  --v2-green-check: #3f8a60;
  --v2-red: #c1121f;
  --v2-gold: #d9a441;
  --v2-purple: #6e5ad9;
  --v2-blue: #3f7bd9;
  --v2-border: rgba(244, 239, 230, 0.12);
  position: relative;
  background: var(--v2-bg);
  color: var(--v2-cream);
  font-family: "Outfit", sans-serif;
  font-weight: 300;
  line-height: 1.6;
}
.v2-landing a {
  color: var(--v2-cream);
  text-decoration: none;
  transition: color 0.2s ease;
}
.v2-landing a:hover {
  color: #fff;
}
.v2-landing ::selection {
  background: var(--v2-green);
  color: var(--v2-cream);
}
.v2-landing em {
  font-style: italic;
}
.v2-landing h1,
.v2-landing h2,
.v2-landing h3 {
  font-family: "Playfair Display", serif;
  font-weight: 500;
}
@media (max-width: 767px) {
  .v2-landing [data-desktop-only] {
    display: none !important;
  }
}
@media (min-width: 768px) {
  .v2-landing [data-mobile-only] {
    display: none !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-landing * {
    animation: none !important;
    transition: none !important;
  }
}

.v2-em-green {
  font-style: italic;
  color: var(--v2-green-light);
}

.v2-em-green-dark {
  font-style: italic;
  color: var(--v2-green);
}

.v2-em-mint {
  font-style: italic;
  color: var(--v2-green-light);
}

.v2-container {
  max-width: 1680px;
  width: 100%;
  margin: 0 auto;
  padding: 0 clamp(24px, 5vw, 96px);
  box-sizing: border-box;
}

.v2-eyebrow {
  margin: 0 0 10px;
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-weight: 500;
  color: var(--v2-muted);
  display: flex;
  align-items: center;
  gap: 10px;
}
.v2-eyebrow i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--v2-red);
  display: inline-block;
}
.v2-eyebrow--mint {
  color: var(--v2-green-light);
  letter-spacing: 0.14em;
  font-size: 13.5px;
}

.v2-section-title {
  font-family: "Playfair Display", serif;
  font-weight: 500;
  font-size: clamp(40px, 5vw, 72px);
  line-height: 1;
  letter-spacing: -0.015em;
  margin: 0;
}
.v2-section-title--center {
  font-size: clamp(56px, 8vw, 128px);
  text-align: center;
  margin: 0 0 48px;
}
.v2-section-title--dark {
  color: #0b0b0c;
}

.v2-reveal {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.7s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.v2-reveal.is-visible {
  opacity: 1;
  transform: translateY(0);
}

.v2-btn {
  display: inline-block;
  border-radius: 999px;
  font-weight: 500;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.v2-btn:hover {
  transform: translateY(-1px);
}
.v2-btn--primary {
  background: var(--v2-green);
  color: var(--v2-cream);
}
.v2-btn--primary:hover {
  box-shadow: 0 10px 24px -8px rgba(47, 106, 74, 0.6);
}
.v2-btn--sm {
  font-size: 14.5px;
  padding: 10px 20px;
}
.v2-btn--md {
  font-size: 16px;
  padding: 15px 32px;
}
.v2-btn--lg {
  font-size: 18px;
  padding: 17px 38px;
}

.v2-header-bar {
  position: fixed;
  top: 16px;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  justify-content: center;
  padding: 0 16px;
}

.v2-navpill {
  display: flex;
  align-items: center;
  gap: 28px;
  background: rgba(11, 11, 12, 0.55);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid var(--v2-border);
  border-radius: 999px;
  padding: 10px 12px 10px 20px;
  max-width: 960px;
  width: 100%;
  justify-content: space-between;
}
.v2-navpill__brand {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-shrink: 0;
}
.v2-navpill__desktop {
  display: contents;
}
.v2-navpill__links {
  display: flex;
  align-items: center;
  gap: 26px;
  font-size: 14.5px;
  font-weight: 400;
  color: var(--v2-muted);
}
.v2-navpill__links a {
  color: var(--v2-muted);
}
.v2-navpill__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.v2-navpill__login {
  font-size: 14.5px;
  color: var(--v2-muted);
  padding: 9px 16px;
  border-radius: 999px;
}
.v2-navpill__mobile {
  display: none;
}

.v2-logo {
  width: auto;
  height: 40px;
  object-fit: contain;
  display: block;
}

.v2-menu-toggle {
  background: none;
  border: 1px solid rgba(244, 239, 230, 0.2);
  border-radius: 999px;
  color: var(--v2-cream);
  padding: 9px 16px;
  font-family: "Outfit", sans-serif;
  font-size: 14px;
  cursor: pointer;
}

.v2-mobile-menu-wrap {
  position: fixed;
  top: 76px;
  left: 16px;
  right: 16px;
  z-index: 49;
}

.v2-mobile-menu {
  background: var(--v2-bg-alt);
  border: 1px solid var(--v2-border);
  border-radius: 24px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: calc(100svh - 96px);
  overflow: auto;
  animation: v2MenuIn 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.v2-mobile-menu a {
  padding: 13px 18px;
  border-radius: 14px;
  font-size: 16px;
}
.v2-mobile-menu__cta {
  margin-top: 8px;
  background: var(--v2-green);
  text-align: center;
  padding: 14px 18px !important;
  border-radius: 999px;
  font-weight: 500;
}

@keyframes v2MenuIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1050px) {
  .v2-navpill__desktop {
    display: none;
  }
  .v2-navpill__mobile {
    display: block;
  }
}
.v2-hero {
  position: relative;
  height: 100svh;
  min-height: 640px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 24px 80px;
  box-sizing: border-box;
}

.v2-hero-collage {
  position: absolute;
  inset: 0;
  overflow: hidden;
}
.v2-hero-collage__wall {
  position: absolute;
  inset: -4%;
  transform: scale(1.04);
  transform-origin: 50% 50%;
  opacity: 1;
  will-change: transform, opacity;
}
.v2-hero-collage__grid {
  position: absolute;
  inset: -2%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(3, 1fr);
  filter: brightness(0.75);
}
.v2-hero-collage__grid-tile {
  background-size: cover;
  background-position: center;
  min-height: 0;
  min-width: 0;
}
.v2-hero-collage__polaroid {
  position: absolute;
  background-size: cover;
  background-position: center;
  border: 6px solid var(--v2-cream);
  border-radius: 3px;
  box-sizing: border-box;
  box-shadow: 0 18px 50px -10px rgba(0, 0, 0, 0.6);
}
.v2-hero-collage__scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: rgba(11, 11, 12, 0.22);
  pointer-events: none;
}

.v2-hero__card {
  position: relative;
  z-index: 2;
  max-width: 980px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(13, 13, 14, 0.9);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid var(--v2-border);
  border-radius: 32px;
  padding: clamp(48px, 6.5vw, 84px) clamp(36px, 7vw, 96px);
  box-shadow: 0 40px 100px -20px rgba(0, 0, 0, 0.7);
  animation: v2HeroCardIn 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@keyframes v2HeroCardIn {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.v2-hero__title {
  font-size: clamp(48px, 6.6vw, 96px);
  line-height: 1.02;
  margin: 0 0 26px;
  letter-spacing: -0.02em;
}
.v2-hero__title em {
  color: var(--v2-red);
}

.v2-hero__subtitle {
  font-size: clamp(17px, 1.4vw, 20px);
  color: var(--v2-muted);
  max-width: 44ch;
  margin: 0 0 44px;
  text-wrap: pretty;
}

.v2-hero__cta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.v2-hero__qr {
  display: flex;
  align-items: center;
  gap: 22px;
}
.v2-hero__qr span {
  font-size: 18px;
  color: var(--v2-cream);
  line-height: 1.4;
  text-align: left;
}

.v2-qr-link {
  display: inline-flex;
  flex-shrink: 0;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  transition: transform 0.2s ease;
}
.v2-qr-link:hover {
  transform: scale(1.03);
}
.v2-qr-link img {
  display: block;
  width: 140px;
  height: 140px;
  image-rendering: pixelated;
}

@media (max-width: 767px) {
  .v2-hero {
    padding: 120px 20px 60px;
  }
  .v2-hero__title {
    font-size: clamp(42px, 10vw, 68px);
  }
  .v2-hero__card {
    padding: 40px 22px;
  }
  .v2-hero__subtitle {
    margin-bottom: 28px;
  }
  .v2-logo {
    width: auto;
    height: 34px;
  }
}
.v2-hiw-section {
  height: calc((3 + 1) * 100svh);
  height: calc((var(--hiw-steps, 3) + 1) * 100svh);
  position: relative;
}

.v2-hiw-snap {
  position: absolute;
  left: 0;
  top: calc((var(--hiw-step) + 0.5) * 100svh);
  width: 1px;
  height: 1px;
  pointer-events: none;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.v2-hiw-stage {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  height: 100svh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 92px 24px 28px;
  box-sizing: border-box;
  background: var(--v2-bg);
  isolation: isolate;
}
.v2-hiw-stage__head {
  max-width: 1680px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px 40px;
  flex-wrap: wrap;
  flex-shrink: 0;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--v2-border);
}
.v2-hiw-stage__head h2 {
  font-size: clamp(30px, 3.2vw, 44px);
  line-height: 1;
  letter-spacing: -0.015em;
  margin: 0;
}
.v2-hiw-stage__head h2 em {
  color: var(--v2-red);
}

.v2-hiw-dots {
  display: flex;
  gap: 2px;
  align-items: center;
}

.v2-hiw-dot {
  -webkit-appearance: none;
          appearance: none;
  border: 0;
  background: none;
  padding: 10px 3px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.v2-hiw-dot::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: rgba(244, 239, 230, 0.25);
  transition: width 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), background 0.4s;
}
.v2-hiw-dot:hover::before {
  background: rgba(244, 239, 230, 0.5);
}
.v2-hiw-dot:focus-visible {
  outline: 2px solid var(--v2-green-light);
  outline-offset: 2px;
  border-radius: 8px;
}
.v2-hiw-dot[data-active=true]::before {
  width: 28px;
  background: var(--v2-red);
}

.v2-hiw-content {
  max-width: 1680px;
  width: 100%;
  margin: 0 auto;
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: 24px 64px;
  gap: 24px 64px;
  align-items: center;
  padding-top: 24px;
  box-sizing: border-box;
}
.v2-hiw-content[data-shift=true] .v2-hiw-copy-column {
  transform: translateX(calc(100% + 64px));
}
.v2-hiw-content[data-shift=true] .v2-hiw-phone-column {
  transform: translateX(calc(-100% - 64px));
}

.v2-hiw-copy-column,
.v2-hiw-phone-column {
  display: grid;
  align-items: center;
  min-width: 0;
  position: relative;
  will-change: transform;
  transition: transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.v2-hiw-copy-column {
  align-self: center;
}

.v2-hiw-phone-column {
  align-items: center;
  justify-items: center;
  height: 100%;
  overflow: hidden;
  border-radius: 28px;
  background: radial-gradient(120% 80% at 50% 0%, #232320 0%, #121210 60%, #0e0e0c 100%);
  border: 1px solid var(--v2-border);
  padding: 24px 0;
  box-sizing: border-box;
}

.v2-hiw-panel {
  grid-area: 1/1;
}

.v2-hiw-copy-panel {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(44px);
  transition: opacity 0.55s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.55s cubic-bezier(0.2, 0.8, 0.2, 1), visibility 0s linear 0.55s;
}
.v2-hiw-copy-panel[data-active=true] {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0);
  transition: opacity 0.55s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.55s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.v2-hiw-copy-panel__eyebrow {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--v2-muted-2);
  font-weight: 500;
}
.v2-hiw-copy-panel__eyebrow b {
  font-family: "Playfair Display", serif;
  font-size: 24px;
  letter-spacing: 0;
  text-transform: none;
  color: var(--v2-red);
  font-weight: 400;
}
.v2-hiw-copy-panel h3 {
  margin: 22px 0 18px;
  font-size: clamp(40px, 5vw, 84px);
  line-height: 1.02;
  letter-spacing: -0.015em;
  text-wrap: balance;
}
.v2-hiw-copy-panel p {
  margin: 0;
  color: var(--v2-muted);
  line-height: 1.55;
  font-size: clamp(17px, 1.5vw, 22px);
  max-width: 40ch;
  text-wrap: pretty;
}

.v2-hiw-phone-panel {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(60px) scale(0.96);
  transition: opacity 0.65s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.65s cubic-bezier(0.2, 0.8, 0.2, 1), visibility 0s linear 0.65s;
  zoom: 1;
  zoom: var(--phone-zoom, 1);
}
.v2-hiw-phone-panel[data-active=true] {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0) scale(1);
  transition: opacity 0.65s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.65s cubic-bezier(0.2, 0.8, 0.2, 1);
}

@media (max-width: 820px) {
  .v2-hiw-content {
    grid-template-columns: minmax(0, 1fr) !important;
    grid-template-rows: auto minmax(0, 1fr);
    gap: 20px !important;
    padding-top: 18px !important;
  }
  .v2-hiw-stage {
    padding: 92px 20px 20px !important;
  }
  .v2-hiw-copy-column,
  .v2-hiw-phone-column {
    transform: none !important;
  }
  .v2-hiw-copy-panel h3 {
    font-size: 32px !important;
    margin: 12px 0 !important;
    line-height: 1.06 !important;
  }
  .v2-hiw-copy-panel p {
    font-size: 16px !important;
    line-height: 1.45 !important;
  }
  .v2-hiw-copy-panel__eyebrow {
    font-size: 10px !important;
  }
  .v2-hiw-phone-column {
    padding: 16px 0 !important;
  }
  .v2-hiw-stage__head {
    padding-bottom: 16px !important;
    gap: 12px !important;
  }
  .v2-hiw-stage__head h2 {
    font-size: 30px !important;
  }
}
@media (max-width: 767px) {
  .v2-hiw-stage__head p {
    margin-bottom: 6px !important;
  }
  .v2-hiw-stage__head h2 {
    font-size: 28px !important;
  }
}
@media (max-height: 700px) and (max-width: 820px) {
  .v2-hiw-copy-panel h3 {
    font-size: 27px !important;
    margin: 8px 0 !important;
  }
  .v2-hiw-copy-panel p {
    font-size: 14px !important;
  }
  .v2-hiw-stage__head h2 {
    font-size: 24px !important;
  }
  .v2-hiw-content {
    gap: 12px !important;
  }
  .v2-hiw-stage {
    padding-top: 86px !important;
  }
  .v2-hiw-stage__head {
    padding-bottom: 10px !important;
  }
}
.v2-phone {
  position: relative;
  width: 236px;
  background: #050505;
  border-radius: 36px;
  padding: 8px;
  box-shadow: 0 40px 60px -30px rgba(0, 0, 0, 0.9), 0 0 0 1px #2a2a26;
  box-sizing: border-box;
}
.v2-phone__screen {
  position: relative;
  width: 100%;
  aspect-ratio: 1206/2622;
  background: #0f1512;
  border-radius: 29px;
  overflow: hidden;
}

.v2-phone__screenshot {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.v2-map-pulses {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.v2-map-pulse {
  position: absolute;
  width: 20%;
  aspect-ratio: 1;
  transform: translate(-50%, -50%);
  --pulse-fill: rgba(170, 1, 0, 0.42);
  --pulse-stroke: rgba(170, 1, 0, 0.85);
}
.v2-map-pulse--hotspot {
  --pulse-fill: rgba(255, 89, 0, 0.4);
  --pulse-stroke: rgba(255, 89, 0, 0.85);
}
.v2-map-pulse > span {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: var(--pulse-fill);
  border: 2px solid var(--pulse-stroke);
  box-sizing: border-box;
  animation: v2MapPulse 3s cubic-bezier(0.33, 1, 0.68, 1) infinite both;
}
.v2-map-pulse > span:nth-child(2) {
  animation-delay: -1s;
}
.v2-map-pulse > span:nth-child(3) {
  animation-delay: -2s;
}
@media (prefers-reduced-motion: reduce) {
  .v2-map-pulse > span:not(:first-child) {
    display: none;
  }
}

@keyframes v2MapPulse {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(1.75);
  }
}
.v2-chat {
  --chat-bg: #101c1c;
  --chat-me: #34433e;
  --chat-them: #faefdb;
  --chat-cream: #f6ead6;
  display: flex;
  flex-direction: column;
  background: var(--chat-bg);
  font-family: "Inter", "Outfit", sans-serif;
  color: var(--chat-cream);
}
.v2-chat__status {
  position: relative;
  height: 30px;
  flex: none;
  font-size: 9.5px;
  font-weight: 600;
  padding: 12px 0 0 24px;
  box-sizing: border-box;
}
.v2-chat__island {
  position: absolute;
  top: 8px;
  left: 50%;
  width: 68px;
  height: 20px;
  margin-left: -34px;
  border-radius: 12px;
  background: #000;
}
.v2-chat__header {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 36px;
  flex: none;
  padding: 0 10px 0 10px;
}
.v2-chat__header svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: var(--chat-cream);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.v2-chat__name {
  flex: 1 1;
  font-size: 12.5px;
  font-weight: 700;
}
.v2-chat__more {
  display: flex;
  flex-direction: column;
  gap: 1.6px;
}
.v2-chat__more i {
  width: 2.6px;
  height: 2.6px;
  border-radius: 50%;
  background: var(--chat-cream);
}
.v2-chat__thread {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 9px 10px;
}
.v2-chat__date {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 2px 0 6px;
  font-size: 6.5px;
}
.v2-chat__date::before, .v2-chat__date::after {
  content: "";
  flex: 1 1;
  height: 0.5px;
  background: #3a4443;
}
.v2-chat__date span {
  padding: 3px 7px;
  border: 0.5px solid #3a4443;
  border-radius: 10px;
}
.v2-chat__row {
  display: flex;
  align-items: center;
  gap: 8px;
  animation: v2ChatIn 0.28s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.v2-chat__row--me {
  justify-content: flex-end;
}
.v2-chat__avatar {
  width: 34px;
  height: 34px;
  flex: none;
  border-radius: 50%;
  object-fit: cover;
}
.v2-chat__bubble {
  max-width: 72%;
  padding: 6px 7px 5px;
  border-radius: 6px;
  font-size: 8.7px;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
.v2-chat__bubble small {
  display: block;
  margin-top: 2px;
  font-size: 5.5px;
  opacity: 0.6;
}
.v2-chat__bubble--me {
  background: var(--chat-me);
  color: var(--chat-cream);
}
.v2-chat__bubble--them {
  background: var(--chat-them);
  color: #1c1c1c;
}
.v2-chat__typing {
  display: flex;
  gap: 3px;
  padding: 9px 9px;
}
.v2-chat__typing i {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #6b6355;
  animation: v2ChatDot 1s ease-in-out infinite;
}
.v2-chat__typing i:nth-child(2) {
  animation-delay: 0.15s;
}
.v2-chat__typing i:nth-child(3) {
  animation-delay: 0.3s;
}
.v2-chat__composer {
  display: flex;
  align-items: center;
  gap: 9px;
  flex: none;
  padding: 0 9px 18px;
}
.v2-chat__input {
  flex: 1 1;
  min-height: 30px;
  display: flex;
  align-items: center;
  padding: 4px 9px;
  box-sizing: border-box;
  border-radius: 6px;
  background: var(--chat-me);
  font-size: 7.5px;
  line-height: 1.3;
  color: #aab3b0;
}
.v2-chat__input[data-typing=true] {
  color: var(--chat-cream);
}
.v2-chat__input[data-typing=true]::after {
  content: "";
  width: 0.8px;
  height: 9px;
  margin-left: 1px;
  background: var(--chat-cream);
  animation: v2ChatCaret 0.9s steps(1) infinite;
}
.v2-chat__send {
  width: 16px;
  height: 16px;
  flex: none;
  fill: #fff;
}

@keyframes v2ChatIn {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes v2ChatDot {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  30% {
    transform: translateY(-2.5px);
    opacity: 1;
  }
}
@keyframes v2ChatCaret {
  50% {
    opacity: 0;
  }
}
@keyframes v2StoryReveal {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.v2-section {
  border-top: 1px solid var(--v2-border);
  padding: 72px 0;
}
.v2-section--dotted {
  background: var(--v2-bg) radial-gradient(rgba(244, 239, 230, 0.09) 1px, transparent 1.2px) 0 0/56px 56px;
}
.v2-section--light {
  background: var(--v2-cream);
  color: #0b0b0c;
}
.v2-section--trust {
  background: var(--v2-bg-alt) radial-gradient(60% 50% at 50% 0%, rgba(63, 138, 96, 0.14), transparent 70%);
}
.v2-section--chicago {
  padding-bottom: 72px;
}

.v2-singles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));
  grid-gap: 48px 80px;
  gap: 48px 80px;
  align-items: center;
}

.v2-singles-copy {
  font-size: clamp(19px, 1.75vw, 27px);
  color: var(--v2-muted);
  max-width: 64ch;
}
.v2-singles-copy h3 {
  font-size: clamp(36px, 3.9vw, 62px);
  line-height: 1.15;
  margin: 0 0 20px;
  letter-spacing: -0.01em;
  color: var(--v2-cream);
  text-wrap: balance;
}
.v2-singles-copy h3:not(:first-child) {
  margin-top: 40px;
}
.v2-singles-copy p {
  margin: 0 0 18px;
  text-wrap: pretty;
}

.v2-singles-testimonials {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.v2-testimonial {
  margin: 0;
  background: rgba(20, 20, 22, 0.85);
  border: 1px solid var(--v2-border);
  border-radius: 22px;
  padding: 36px 40px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  opacity: 0;
  transform: translateY(16px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}
.v2-reveal.is-visible .v2-testimonial {
  opacity: 1;
  transform: translateY(0);
}
.v2-testimonial figcaption {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 17px;
  color: var(--v2-cream);
  font-weight: 400;
}
.v2-testimonial__stars {
  display: flex;
  gap: 3px;
}
.v2-testimonial blockquote {
  margin: 0;
  font-family: "Playfair Display", serif;
  font-style: italic;
  font-size: clamp(22px, 1.9vw, 29px);
  line-height: 1.4;
  font-weight: 400;
  text-wrap: pretty;
}

.v2-venues-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 340px), 1fr));
  grid-gap: 48px 80px;
  gap: 48px 80px;
  align-items: center;
  margin-bottom: 72px;
}
.v2-venues-row--reverse {
  margin-bottom: 0;
}
.v2-venues-row h3 {
  font-size: clamp(38px, 4.1vw, 66px);
  line-height: 1.1;
  margin: 0 0 26px;
  letter-spacing: -0.01em;
  color: var(--v2-green);
}
.v2-venues-row p {
  margin: 0 0 18px;
  font-size: clamp(19px, 1.75vw, 27px);
  color: #4a463f;
  max-width: 60ch;
  text-wrap: pretty;
}

.v2-venue-photo {
  margin: 0;
}
.v2-venue-photo img {
  display: block;
  width: 100%;
  aspect-ratio: 4/3;
  object-fit: cover;
  border-radius: 18px;
}

.v2-checklist {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.v2-checklist li {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  font-size: clamp(19px, 1.75vw, 27px);
  color: var(--v2-cream);
  line-height: 1.5;
}
.v2-checklist li svg {
  flex-shrink: 0;
  transform: translateY(4px);
}
.v2-checklist--dark li {
  color: #0b0b0c;
}

.v2-trust-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));
  grid-gap: 48px 80px;
  gap: 48px 80px;
  align-items: center;
}
.v2-trust-grid h3 {
  font-size: clamp(36px, 3.9vw, 62px);
  line-height: 1.15;
  margin: 0 0 28px;
  letter-spacing: -0.01em;
  color: var(--v2-cream);
  text-wrap: balance;
}

.v2-trust-copy {
  font-size: clamp(19px, 1.75vw, 27px);
  color: var(--v2-muted);
  max-width: 64ch;
}
.v2-trust-copy p {
  margin: 0 0 18px;
  text-wrap: pretty;
}

.v2-chicago-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  flex-wrap: wrap;
  padding-bottom: 40px;
}
.v2-chicago-head h2 {
  margin: 0;
}

.v2-chicago-blurb {
  margin: 0;
  color: var(--v2-muted);
  font-size: clamp(17px, 1.4vw, 21px);
  max-width: 40ch;
  text-wrap: pretty;
}

.v2-chicago-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 16px;
  gap: 16px;
}
@media (max-width: 1023px) {
  .v2-chicago-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.v2-venue-card {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  background: var(--v2-bg-alt);
  border: 1px solid var(--v2-border);
  border-radius: 20px;
  padding: 26px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 190px;
  opacity: 0;
  transform: translateY(16px);
  transition: opacity 0.6s ease, transform 0.6s ease, border-color 0.2s ease;
}
.v2-reveal.is-visible .v2-venue-card {
  opacity: 1;
  transform: translateY(0);
}
.v2-venue-card:hover {
  border-color: rgba(111, 168, 134, 0.4);
}
.v2-venue-card::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(to top, var(--v2-bg-alt) 18%, rgba(20, 20, 22, 0.55) 55%, rgba(20, 20, 22, 0.15) 100%);
  pointer-events: none;
}
.v2-venue-card:hover .v2-venue-card__logo {
  opacity: 0.3;
  transform: scale(1.04);
}
.v2-venue-card--placeholder {
  background: linear-gradient(100deg, var(--v2-bg-alt) 40%, #1c1c1f 50%, var(--v2-bg-alt) 60%) 0 0/300% 100%;
  animation: v2VenueShimmer 1.6s linear infinite;
}
.v2-venue-card__logo {
  position: absolute;
  z-index: -2;
  inset: 6% 10%;
  width: 80%;
  height: 88%;
  object-fit: contain;
  opacity: 0.2;
  filter: grayscale(1) sepia(0.3) brightness(1.15);
  pointer-events: none;
  -webkit-mask-image: radial-gradient(closest-side, #000 60%, transparent 100%);
  mask-image: radial-gradient(closest-side, #000 60%, transparent 100%);
  transition: opacity 0.3s ease, transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.v2-venue-card__top {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 16px;
}
.v2-venue-card__stat {
  font-size: 12px;
  letter-spacing: 0.04em;
  color: var(--v2-green-light);
  font-weight: 500;
}
.v2-venue-card__pulse {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--v2-green-check);
  animation: v2VenuePulse 2.4s ease-out infinite;
}
.v2-venue-card__body {
  margin-top: auto;
}
.v2-venue-card__name {
  margin: 0 0 4px;
  font-family: "Playfair Display", serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
}
.v2-venue-card__area {
  margin: 0;
  font-size: 12.5px;
  color: var(--v2-muted);
  letter-spacing: 0.04em;
}

@keyframes v2VenueShimmer {
  to {
    background-position: -300% 0;
  }
}
@keyframes v2VenuePulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(63, 138, 96, 0.5);
  }
  60% {
    box-shadow: 0 0 0 7px rgba(63, 138, 96, 0);
  }
}
@media (max-width: 767px) {
  .v2-chicago-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .v2-venue-card {
    padding: 20px 14px !important;
  }
}
.v2-about {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1300px;
  margin: 0 auto;
  padding: 96px clamp(24px, 5vw, 96px);
  text-align: center;
  box-sizing: border-box;
}
.v2-about__title {
  font-style: italic;
  font-size: clamp(48px, 7vw, 104px);
  line-height: 1.02;
  margin: 0 0 32px;
  letter-spacing: -0.015em;
  text-wrap: balance;
}
.v2-about__body {
  margin: 0 auto;
  color: var(--v2-muted);
  font-size: clamp(18px, 1.6vw, 24px);
  max-width: 60ch;
  text-wrap: pretty;
}

.v2-download {
  border-top: 1px solid var(--v2-border);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 96px clamp(24px, 5vw, 96px);
  text-align: center;
  box-sizing: border-box;
}
.v2-download__title {
  font-size: clamp(44px, 6vw, 88px);
  line-height: 1.05;
  margin: 0 0 18px;
  letter-spacing: -0.015em;
}
.v2-download__title em {
  color: var(--v2-red);
}
.v2-download__subtitle {
  margin: 0 0 40px;
  color: var(--v2-muted);
  font-size: 18px;
}
.v2-download__cta-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 22px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.v2-download__qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.v2-download__qr span {
  font-size: 13px;
  color: var(--v2-muted);
  text-align: center;
  line-height: 1.4;
}
.v2-download__stores {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
.v2-download__stores a {
  border: 1px solid rgba(244, 239, 230, 0.22);
  border-radius: 999px;
  padding: 9px 18px;
  font-size: 13.5px;
  color: var(--v2-muted);
  transition: border-color 0.2s ease;
}
.v2-download__stores a:hover {
  border-color: rgba(244, 239, 230, 0.5);
}
.v2-download__disclaimer {
  margin: 26px 0 0;
  font-size: 13.5px;
  color: var(--v2-muted);
  opacity: 0.85;
}

@media (max-width: 767px) {
  .v2-download__qr {
    display: none;
  }
}
.v2-footer {
  border-top: 1px solid var(--v2-border);
  padding: 56px 24px 44px;
}
.v2-footer__row {
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
}
.v2-footer__row > div:first-child .v2-logo {
  margin-bottom: 18px;
}
.v2-footer__row > div:first-child p {
  margin: 0 0 6px;
  font-size: 14px;
  color: var(--v2-muted);
}
.v2-footer__row > div:first-child p a {
  color: var(--v2-muted);
}
.v2-footer__links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
}
.v2-footer__links span {
  color: var(--v2-muted);
}
.v2-footer__legal-link {
  text-decoration: underline;
  text-underline-offset: 3px;
}`, "",{"version":3,"sources":["webpack://./src/pages/landing/v2/styles/landing-v2.scss"],"names":[],"mappings":"AAKA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sCAAA;EAEA,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;AAJF;AAME;EACE,sBAAA;EACA,qBAAA;EACA,2BAAA;AAJJ;AAKI;EACE,WAAA;AAHN;AAOE;EACE,2BAAA;EACA,sBAAA;AALJ;AAQE;EACE,kBAAA;AANJ;AASE;;;EAGE,sCAAA;EACA,gBAAA;AAPJ;AAUE;EACE;IACE,wBAAA;EARJ;AACF;AAUE;EACE;IACE,wBAAA;EARJ;AACF;AAWE;EACE;IACE,0BAAA;IACA,2BAAA;EATJ;AACF;;AAaA;EACE,kBAAA;EACA,4BAAA;AAVF;;AAYA;EACE,kBAAA;EACA,sBAAA;AATF;;AAWA;EACE,kBAAA;EACA,4BAAA;AARF;;AAWA;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iCAAA;EACA,sBAAA;AARF;;AAWA;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AARF;AAUE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AARJ;AAWE;EACE,4BAAA;EACA,sBAAA;EACA,iBAAA;AATJ;;AAaA;EACE,sCAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;EACA,wBAAA;EACA,SAAA;AAVF;AAYE;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;;AAkBA;EACE,UAAA;EACA,2BAAA;EACA,sGAAA;AAfF;AAiBE;EACE,UAAA;EACA,wBAAA;AAfJ;;AAsBA;EACE,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,2EAAA;AAnBF;AAqBE;EACE,2BAAA;AAnBJ;AAsBE;EACE,2BAAA;EACA,sBAAA;AApBJ;AAqBI;EACE,mDAAA;AAnBN;AAuBE;EACE,iBAAA;EACA,kBAAA;AArBJ;AAuBE;EACE,eAAA;EACA,kBAAA;AArBJ;AAuBE;EACE,eAAA;EACA,kBAAA;AArBJ;;AA4BA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;EACA,2BAAA;EACA,mCAAA;EACA,kCAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,WAAA;EACA,8BAAA;AAzBF;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAzBJ;AA4BE;EACE,iBAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AA3BJ;AA6BI;EACE,sBAAA;AA3BN;AA+BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA7BJ;AAgCE;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;AA9BJ;AAiCE;EACE,aAAA;AA/BJ;;AAmCA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,gBAAA;EACA,0CAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;AAhCF;;AAmCA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AAhCF;;AAmCA;EACE,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,+BAAA;EACA,cAAA;EACA,wDAAA;AAhCF;AAkCE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;AAhCJ;AAmCE;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,6BAAA;EACA,oBAAA;EACA,gBAAA;AAjCJ;;AAqCA;EACE;IACE,UAAA;IACA,2BAAA;EAlCF;EAoCA;IACE,UAAA;IACA,wBAAA;EAlCF;AACF;AAqCA;EACE;IACE,aAAA;EAnCF;EAqCA;IACE,cAAA;EAnCF;AACF;AAyCA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;AAvCF;;AA0CA;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;AAvCF;AAyCE;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;EACA,+BAAA;AAvCJ;AA0CE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,wBAAA;AAxCJ;AA2CE;EACE,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;AAzCJ;AA4CE;EACE,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,iCAAA;EACA,kBAAA;EACA,sBAAA;EACA,gDAAA;AA1CJ;AA6CE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kCAAA;EACA,oBAAA;AA3CJ;;AA+CA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iCAAA;EACA,0BAAA;EACA,kCAAA;EACA,kCAAA;EACA,mBAAA;EACA,wDAAA;EACA,iDAAA;EACA,gEAAA;AA5CF;;AA+CA;EACE;IACE,UAAA;IACA,2BAAA;EA5CF;EA8CA;IACE,UAAA;IACA,wBAAA;EA5CF;AACF;AA+CA;EACE,mCAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AA7CF;AA+CE;EACE,oBAAA;AA7CJ;;AAiDA;EACE,mCAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA9CF;AAgDE;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AA9CJ;;AAkDA;EACE,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;AA/CF;AAiDE;EACE,sBAAA;AA/CJ;AAkDE;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;AAhDJ;;AAoDA;EACE;IACE,wBAAA;EAjDF;EAmDA;IACE,kCAAA;EAjDF;EAmDA;IACE,kBAAA;EAjDF;EAmDA;IACE,mBAAA;EAjDF;EAmDA;IACE,WAAA;IACA,YAAA;EAjDF;AACF;AAuDA;EAEE,8BAAA;EAAA,gDAAA;EACA,kBAAA;AAtDF;;AA4DA;EACE,kBAAA;EACA,OAAA;EACA,2CAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;AAzDF;AA2DE;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,yCAAA;AAzDJ;AA2DI;EACE,mCAAA;EACA,cAAA;EACA,wBAAA;EACA,SAAA;AAzDN;AA2DM;EACE,oBAAA;AAzDR;;AA+DA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AA5DF;;AAgEA;EACE,wBAAA;UAAA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AA7DF;AA+DE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,sEAAA;AA7DJ;AAgEE;EACE,oCAAA;AA9DJ;AAiEE;EACE,wCAAA;EACA,mBAAA;EACA,kBAAA;AA/DJ;AAkEE;EACE,WAAA;EACA,yBAAA;AAhEJ;;AAoEA;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,oDAAA;EACA,mBAAA;EAAA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;AAjEF;AAmEE;EACE,wCAAA;AAjEJ;AAmEE;EACE,yCAAA;AAjEJ;;AAqEA;;EAEE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,yDAAA;AAlEF;;AAqEA;EACE,kBAAA;AAlEF;;AAqEA;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,sFAAA;EACA,kCAAA;EACA,eAAA;EACA,sBAAA;AAlEF;;AAqEA;EACE,cAAA;AAlEF;;AAqEA;EACE,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,2BAAA;EACA,oIAAA;AAlEF;AAoEE;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,wGAAA;AAlEJ;AAqEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,gBAAA;AAnEJ;AAqEI;EACE,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;AAnEN;AAuEE;EACE,mBAAA;EACA,iCAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;AArEJ;AAwEE;EACE,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,mCAAA;EACA,eAAA;EACA,iBAAA;AAtEJ;;AA0EA;EACE,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,uCAAA;EACA,oIAAA;EACA,OAAA;EAAA,0BAAA;AAvEF;AAyEE;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,iCAAA;EACA,wGAAA;AAvEJ;;AA2EA;EACE;IACE,gDAAA;IACA,uCAAA;IACA,oBAAA;IACA,4BAAA;EAxEF;EA0EA;IACE,kCAAA;EAxEF;EA0EA;;IAEE,0BAAA;EAxEF;EA0EA;IACE,0BAAA;IACA,yBAAA;IACA,4BAAA;EAxEF;EA0EA;IACE,0BAAA;IACA,4BAAA;EAxEF;EA0EA;IACE,0BAAA;EAxEF;EA0EA;IACE,0BAAA;EAxEF;EA0EA;IACE,+BAAA;IACA,oBAAA;EAxEF;EA0EA;IACE,0BAAA;EAxEF;AACF;AA2EA;EACE;IACE,6BAAA;EAzEF;EA2EA;IACE,0BAAA;EAzEF;AACF;AA4EA;EACE;IACE,0BAAA;IACA,wBAAA;EA1EF;EA4EA;IACE,0BAAA;EA1EF;EA4EA;IACE,0BAAA;EA1EF;EA4EA;IACE,oBAAA;EA1EF;EA4EA;IACE,4BAAA;EA1EF;EA4EA;IACE,+BAAA;EA1EF;AACF;AAkFA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,mEAAA;EACA,sBAAA;AAhFF;AAkFE;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAhFJ;;AAqFA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAlFF;;AAwFA;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;AArFF;;AAwFA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gCAAA;EAGA,mCAAA;EACA,qCAAA;AAvFF;AA0FE;EACE,mCAAA;EACA,sCAAA;AAxFJ;AA2FE;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;EACA,sBAAA;EACA,qEAAA;AAzFJ;AA2FI;EACE,oBAAA;AAzFN;AA4FI;EACE,oBAAA;AA1FN;AA8FE;EACE;IACE,aAAA;EA5FJ;AACF;;AAgGA;EACE;IACE,UAAA;IACA,mBAAA;EA7FF;EA+FA;IACE,UAAA;IACA,sBAAA;EA7FF;AACF;AAmGA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EAEA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,0CAAA;EACA,wBAAA;AAlGF;AAoGE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAlGJ;AAqGE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAnGJ;AAsGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;AApGJ;AAsGI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;AApGN;AAwGE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AAtGJ;AAyGE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AAvGJ;AAyGI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;AAvGN;AA2GE;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,qBAAA;AAzGJ;AA4GE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AA1GJ;AA4GI;EAEE,WAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AA3GN;AA8GI;EACE,gBAAA;EACA,2BAAA;EACA,mBAAA;AA5GN;AAgHE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,6DAAA;AA9GJ;AAgHI;EACE,yBAAA;AA9GN;AAkHE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAhHJ;AAmHE;EACE,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAjHJ;AAmHI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAjHN;AAoHI;EACE,0BAAA;EACA,wBAAA;AAlHN;AAqHI;EACE,4BAAA;EACA,cAAA;AAnHN;AAuHE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AArHJ;AAuHI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;AArHN;AAuHM;EACE,sBAAA;AArHR;AAwHM;EACE,qBAAA;AAtHR;AA2HE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;AAzHJ;AA4HE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA1HJ;AA4HI;EACE,wBAAA;AA1HN;AA4HM;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,6CAAA;AA1HR;AA+HE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AA7HJ;;AAiIA;EACE;IACE,UAAA;IACA,sCAAA;EA9HF;EAgIA;IACE,UAAA;IACA,eAAA;EA9HF;AACF;AAiIA;EACE;IAGE,wBAAA;IACA,aAAA;EAjIF;EAmIA;IACE,6BAAA;IACA,UAAA;EAjIF;AACF;AAoIA;EACE;IACE,UAAA;EAlIF;AACF;AAsIA;EACE;IACE,UAAA;IACA,0BAAA;EApIF;EAsIA;IACE,UAAA;IACA,wBAAA;EApIF;AACF;AA0IA;EACE,sCAAA;EACA,eAAA;AAxIF;AA0IE;EACE,wGAAA;AAxIJ;AA2IE;EACE,2BAAA;EACA,cAAA;AAzIJ;AA4IE;EACE,yGAAA;AA1IJ;AA6IE;EACE,oBAAA;AA3IJ;;AAgJA;EACE,aAAA;EACA,sEAAA;EACA,mBAAA;EAAA,cAAA;EACA,mBAAA;AA7IF;;AAgJA;EACE,oCAAA;EACA,sBAAA;EACA,eAAA;AA7IF;AA+IE;EACE,mCAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AA7IJ;AA+II;EACE,gBAAA;AA7IN;AAiJE;EACE,gBAAA;EACA,iBAAA;AA/IJ;;AAmJA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhJF;;AAmJA;EACE,SAAA;EACA,kCAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kCAAA;UAAA,0BAAA;EACA,UAAA;EACA,2BAAA;EACA,kDAAA;AAhJF;AAkJE;EACE,UAAA;EACA,wBAAA;AAhJJ;AAmJE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAjJJ;AAoJE;EACE,aAAA;EACA,QAAA;AAlJJ;AAqJE;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAnJJ;;AAwJA;EACE,aAAA;EACA,sEAAA;EACA,mBAAA;EAAA,cAAA;EACA,mBAAA;EACA,mBAAA;AArJF;AAuJE;EACE,gBAAA;AArJJ;AAwJE;EACE,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AAtJJ;AAyJE;EACE,gBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAvJJ;;AA2JA;EACE,SAAA;AAxJF;AA0JE;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAxJJ;;AA4JA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAzJF;AA2JE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,gBAAA;AAzJJ;AA2JI;EACE,cAAA;EACA,0BAAA;AAzJN;AA8JE;EACE,cAAA;AA5JJ;;AAiKA;EACE,aAAA;EACA,sEAAA;EACA,mBAAA;EAAA,cAAA;EACA,mBAAA;AA9JF;AAgKE;EACE,mCAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AA9JJ;;AAkKA;EACE,oCAAA;EACA,sBAAA;EACA,eAAA;AA/JF;AAiKE;EACE,gBAAA;EACA,iBAAA;AA/JJ;;AAoKA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;AAjKF;AAmKE;EACE,SAAA;AAjKJ;;AAqKA;EACE,SAAA;EACA,sBAAA;EACA,mCAAA;EACA,eAAA;EACA,iBAAA;AAlKF;;AAqKA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EAAA,SAAA;AAlKF;AAoKE;EALF;IAMI,gDAAA;EAjKF;AACF;;AAoKA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;EACA,2BAAA;EACA,0EAAA;AAjKF;AAmKE;EACE,UAAA;EACA,wBAAA;AAjKJ;AAoKE;EACE,sCAAA;AAlKJ;AAsKE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kHAAA;EACA,oBAAA;AApKJ;AAuKE;EACE,YAAA;EACA,sBAAA;AArKJ;AAwKE;EACE,0GAAA;EACA,8CAAA;AAtKJ;AA2KE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,gDAAA;EACA,oBAAA;EACA,6EAAA;EACA,qEAAA;EACA,4EAAA;AAzKJ;AA4KE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AA1KJ;AA6KE;EACE,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;AA3KJ;AA8KE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,8CAAA;AA5KJ;AA+KE;EACE,gBAAA;AA7KJ;AAgLE;EACE,eAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA9KJ;AAiLE;EACE,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;AA/KJ;;AAmLA;EACE;IACE,4BAAA;EAhLF;AACF;AAmLA;EACE;IAEE,0CAAA;EAlLF;EAoLA;IACE,0CAAA;EAlLF;AACF;AAqLA;EACE;IACE,2DAAA;EAnLF;EAqLA;IACE,6BAAA;EAnLF;AACF;AAuLA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,sBAAA;AArLF;AAuLE;EACE,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;AArLJ;AAwLE;EACE,cAAA;EACA,sBAAA;EACA,mCAAA;EACA,eAAA;EACA,iBAAA;AAtLJ;;AA2LA;EACE,sCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,sBAAA;AAxLF;AA0LE;EACE,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;AAxLJ;AA0LI;EACE,oBAAA;AAxLN;AA4LE;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;AA1LJ;AA6LE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AA3LJ;AA8LE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA5LJ;AA8LI;EACE,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AA5LN;AAgME;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AA9LJ;AAgMI;EACE,2CAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kCAAA;AA9LN;AAgMM;EACE,sCAAA;AA9LR;AAmME;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;AAjMJ;;AAqMA;EACE;IACE,aAAA;EAlMF;AACF;AAsMA;EACE,sCAAA;EACA,uBAAA;AApMF;AAsME;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AApMJ;AAuMM;EACE,mBAAA;AArMR;AAwMM;EACE,eAAA;EACA,eAAA;EACA,sBAAA;AAtMR;AAwMQ;EACE,sBAAA;AAtMV;AA4ME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AA1MJ;AA4MI;EACE,sBAAA;AA1MN;AA8ME;EACE,0BAAA;EACA,0BAAA;AA5MJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&display=swap');\n\n// ---------------------------------------------------------------------------\n// Palette & tokens\n// ---------------------------------------------------------------------------\n.v2-landing {\n  --v2-bg: #0b0b0c;\n  --v2-bg-alt: #141416;\n  --v2-cream: #f4efe6;\n  --v2-muted: #b7b0a6;\n  --v2-muted-2: #7e7a70;\n  --v2-green: #2f6a4a;\n  --v2-green-light: #6fa886;\n  --v2-green-check: #3f8a60;\n  --v2-red: #c1121f;\n  --v2-gold: #d9a441;\n  --v2-purple: #6e5ad9;\n  --v2-blue: #3f7bd9;\n  --v2-border: rgba(244, 239, 230, 0.12);\n\n  position: relative;\n  background: var(--v2-bg);\n  color: var(--v2-cream);\n  font-family: 'Outfit', sans-serif;\n  font-weight: 300;\n  line-height: 1.6;\n\n  a {\n    color: var(--v2-cream);\n    text-decoration: none;\n    transition: color 0.2s ease;\n    &:hover {\n      color: #fff;\n    }\n  }\n\n  ::selection {\n    background: var(--v2-green);\n    color: var(--v2-cream);\n  }\n\n  em {\n    font-style: italic;\n  }\n\n  h1,\n  h2,\n  h3 {\n    font-family: 'Playfair Display', serif;\n    font-weight: 500;\n  }\n\n  @media (max-width: 767px) {\n    [data-desktop-only] {\n      display: none !important;\n    }\n  }\n  @media (min-width: 768px) {\n    [data-mobile-only] {\n      display: none !important;\n    }\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    * {\n      animation: none !important;\n      transition: none !important;\n    }\n  }\n}\n\n.v2-em-green {\n  font-style: italic;\n  color: var(--v2-green-light);\n}\n.v2-em-green-dark {\n  font-style: italic;\n  color: var(--v2-green);\n}\n.v2-em-mint {\n  font-style: italic;\n  color: var(--v2-green-light);\n}\n\n.v2-container {\n  max-width: 1680px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 clamp(24px, 5vw, 96px);\n  box-sizing: border-box;\n}\n\n.v2-eyebrow {\n  margin: 0 0 10px;\n  font-size: 12px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  font-weight: 500;\n  color: var(--v2-muted);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  i {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: var(--v2-red);\n    display: inline-block;\n  }\n\n  &--mint {\n    color: var(--v2-green-light);\n    letter-spacing: 0.14em;\n    font-size: 13.5px;\n  }\n}\n\n.v2-section-title {\n  font-family: 'Playfair Display', serif;\n  font-weight: 500;\n  font-size: clamp(40px, 5vw, 72px);\n  line-height: 1;\n  letter-spacing: -0.015em;\n  margin: 0;\n\n  &--center {\n    font-size: clamp(56px, 8vw, 128px);\n    text-align: center;\n    margin: 0 0 48px;\n  }\n\n  &--dark {\n    color: #0b0b0c;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Reveal-on-scroll utility\n// ---------------------------------------------------------------------------\n.v2-reveal {\n  opacity: 0;\n  transform: translateY(28px);\n  transition: opacity 0.7s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.7s cubic-bezier(0.2, 0.8, 0.2, 1);\n\n  &.is-visible {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Buttons\n// ---------------------------------------------------------------------------\n.v2-btn {\n  display: inline-block;\n  border-radius: 999px;\n  font-weight: 500;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n\n  &:hover {\n    transform: translateY(-1px);\n  }\n\n  &--primary {\n    background: var(--v2-green);\n    color: var(--v2-cream);\n    &:hover {\n      box-shadow: 0 10px 24px -8px rgba(47, 106, 74, 0.6);\n    }\n  }\n\n  &--sm {\n    font-size: 14.5px;\n    padding: 10px 20px;\n  }\n  &--md {\n    font-size: 16px;\n    padding: 15px 32px;\n  }\n  &--lg {\n    font-size: 18px;\n    padding: 17px 38px;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Header / nav\n// ---------------------------------------------------------------------------\n.v2-header-bar {\n  position: fixed;\n  top: 16px;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  display: flex;\n  justify-content: center;\n  padding: 0 16px;\n}\n\n.v2-navpill {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  background: rgba(11, 11, 12, 0.55);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid var(--v2-border);\n  border-radius: 999px;\n  padding: 10px 12px 10px 20px;\n  max-width: 960px;\n  width: 100%;\n  justify-content: space-between;\n\n  &__brand {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    flex-shrink: 0;\n  }\n\n  &__desktop {\n    display: contents;\n  }\n\n  &__links {\n    display: flex;\n    align-items: center;\n    gap: 26px;\n    font-size: 14.5px;\n    font-weight: 400;\n    color: var(--v2-muted);\n\n    a {\n      color: var(--v2-muted);\n    }\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__login {\n    font-size: 14.5px;\n    color: var(--v2-muted);\n    padding: 9px 16px;\n    border-radius: 999px;\n  }\n\n  &__mobile {\n    display: none;\n  }\n}\n\n.v2-logo {\n  width: auto;\n  height: 40px;\n  object-fit: contain;\n  display: block;\n}\n\n.v2-menu-toggle {\n  background: none;\n  border: 1px solid rgba(244, 239, 230, 0.2);\n  border-radius: 999px;\n  color: var(--v2-cream);\n  padding: 9px 16px;\n  font-family: 'Outfit', sans-serif;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.v2-mobile-menu-wrap {\n  position: fixed;\n  top: 76px;\n  left: 16px;\n  right: 16px;\n  z-index: 49;\n}\n\n.v2-mobile-menu {\n  background: var(--v2-bg-alt);\n  border: 1px solid var(--v2-border);\n  border-radius: 24px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-height: calc(100svh - 96px);\n  overflow: auto;\n  animation: v2MenuIn 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);\n\n  a {\n    padding: 13px 18px;\n    border-radius: 14px;\n    font-size: 16px;\n  }\n\n  &__cta {\n    margin-top: 8px;\n    background: var(--v2-green);\n    text-align: center;\n    padding: 14px 18px !important;\n    border-radius: 999px;\n    font-weight: 500;\n  }\n}\n\n@keyframes v2MenuIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 1050px) {\n  .v2-navpill__desktop {\n    display: none;\n  }\n  .v2-navpill__mobile {\n    display: block;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Hero\n// ---------------------------------------------------------------------------\n.v2-hero {\n  position: relative;\n  height: 100svh;\n  min-height: 640px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 120px 24px 80px;\n  box-sizing: border-box;\n}\n\n.v2-hero-collage {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n\n  &__wall {\n    position: absolute;\n    inset: -4%;\n    transform: scale(1.04);\n    transform-origin: 50% 50%;\n    opacity: 1;\n    will-change: transform, opacity;\n  }\n\n  &__grid {\n    position: absolute;\n    inset: -2%;\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n    filter: brightness(0.75);\n  }\n\n  &__grid-tile {\n    background-size: cover;\n    background-position: center;\n    min-height: 0;\n    min-width: 0;\n  }\n\n  &__polaroid {\n    position: absolute;\n    background-size: cover;\n    background-position: center;\n    border: 6px solid var(--v2-cream);\n    border-radius: 3px;\n    box-sizing: border-box;\n    box-shadow: 0 18px 50px -10px rgba(0, 0, 0, 0.6);\n  }\n\n  &__scrim {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    background: rgba(11, 11, 12, 0.22);\n    pointer-events: none;\n  }\n}\n\n.v2-hero__card {\n  position: relative;\n  z-index: 2;\n  max-width: 980px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: rgba(13, 13, 14, 0.9);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid var(--v2-border);\n  border-radius: 32px;\n  padding: clamp(48px, 6.5vw, 84px) clamp(36px, 7vw, 96px);\n  box-shadow: 0 40px 100px -20px rgba(0, 0, 0, 0.7);\n  animation: v2HeroCardIn 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n@keyframes v2HeroCardIn {\n  from {\n    opacity: 0;\n    transform: translateY(18px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.v2-hero__title {\n  font-size: clamp(48px, 6.6vw, 96px);\n  line-height: 1.02;\n  margin: 0 0 26px;\n  letter-spacing: -0.02em;\n\n  em {\n    color: var(--v2-red);\n  }\n}\n\n.v2-hero__subtitle {\n  font-size: clamp(17px, 1.4vw, 20px);\n  color: var(--v2-muted);\n  max-width: 44ch;\n  margin: 0 0 44px;\n  text-wrap: pretty;\n}\n\n.v2-hero__cta-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.v2-hero__qr {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n\n  span {\n    font-size: 18px;\n    color: var(--v2-cream);\n    line-height: 1.4;\n    text-align: left;\n  }\n}\n\n.v2-qr-link {\n  display: inline-flex;\n  flex-shrink: 0;\n  background: #fff;\n  border-radius: 14px;\n  overflow: hidden;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(1.03);\n  }\n\n  img {\n    display: block;\n    width: 140px;\n    height: 140px;\n    image-rendering: pixelated;\n  }\n}\n\n@media (max-width: 767px) {\n  .v2-hero {\n    padding: 120px 20px 60px;\n  }\n  .v2-hero__title {\n    font-size: clamp(42px, 10vw, 68px);\n  }\n  .v2-hero__card {\n    padding: 40px 22px;\n  }\n  .v2-hero__subtitle {\n    margin-bottom: 28px;\n  }\n  .v2-logo {\n    width: auto;\n    height: 34px;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// How it works — sticky scroll section\n// ---------------------------------------------------------------------------\n.v2-hiw-section {\n  // (steps + 1) screens: one full screen of scrolling per step, plus the sticky stage itself.\n  height: calc((var(--hiw-steps, 3) + 1) * 100svh);\n  position: relative;\n}\n\n// Snap stop in the middle of each step's screen of scrolling (same spot the step dots scroll to).\n// `scroll-snap-stop: always` makes the browser stop here instead of flinging past the step.\n// The root's scroll-snap-type is set by useHowItWorksScroll while the landing page is mounted.\n.v2-hiw-snap {\n  position: absolute;\n  left: 0;\n  top: calc((var(--hiw-step) + 0.5) * 100svh);\n  width: 1px;\n  height: 1px;\n  pointer-events: none;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n}\n\n.v2-hiw-stage {\n  position: sticky;\n  top: 0;\n  height: 100svh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 92px 24px 28px;\n  box-sizing: border-box;\n  background: var(--v2-bg);\n  isolation: isolate;\n\n  &__head {\n    max-width: 1680px;\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 24px 40px;\n    flex-wrap: wrap;\n    flex-shrink: 0;\n    padding-bottom: 20px;\n    border-bottom: 1px solid var(--v2-border);\n\n    h2 {\n      font-size: clamp(30px, 3.2vw, 44px);\n      line-height: 1;\n      letter-spacing: -0.015em;\n      margin: 0;\n\n      em {\n        color: var(--v2-red);\n      }\n    }\n  }\n}\n\n.v2-hiw-dots {\n  display: flex;\n  gap: 2px;\n  align-items: center;\n}\n\n// The visible dot is drawn by ::before; the button itself is a larger hit area.\n.v2-hiw-dot {\n  appearance: none;\n  border: 0;\n  background: none;\n  padding: 10px 3px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n\n  &::before {\n    content: '';\n    width: 8px;\n    height: 8px;\n    border-radius: 4px;\n    background: rgba(244, 239, 230, 0.25);\n    transition: width 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), background 0.4s;\n  }\n\n  &:hover::before {\n    background: rgba(244, 239, 230, 0.5);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--v2-green-light);\n    outline-offset: 2px;\n    border-radius: 8px;\n  }\n\n  &[data-active='true']::before {\n    width: 28px;\n    background: var(--v2-red);\n  }\n}\n\n.v2-hiw-content {\n  max-width: 1680px;\n  width: 100%;\n  margin: 0 auto;\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 24px 64px;\n  align-items: center;\n  padding-top: 24px;\n  box-sizing: border-box;\n\n  &[data-shift='true'] .v2-hiw-copy-column {\n    transform: translateX(calc(100% + 64px));\n  }\n  &[data-shift='true'] .v2-hiw-phone-column {\n    transform: translateX(calc(-100% - 64px));\n  }\n}\n\n.v2-hiw-copy-column,\n.v2-hiw-phone-column {\n  display: grid;\n  align-items: center;\n  min-width: 0;\n  position: relative;\n  will-change: transform;\n  transition: transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.v2-hiw-copy-column {\n  align-self: center;\n}\n\n.v2-hiw-phone-column {\n  align-items: center;\n  justify-items: center;\n  height: 100%;\n  overflow: hidden;\n  border-radius: 28px;\n  background: radial-gradient(120% 80% at 50% 0%, #232320 0%, #121210 60%, #0e0e0c 100%);\n  border: 1px solid var(--v2-border);\n  padding: 24px 0;\n  box-sizing: border-box;\n}\n\n.v2-hiw-panel {\n  grid-area: 1 / 1;\n}\n\n.v2-hiw-copy-panel {\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transform: translateY(44px);\n  transition: opacity 0.55s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.55s cubic-bezier(0.2, 0.8, 0.2, 1), visibility 0s linear 0.55s;\n\n  &[data-active='true'] {\n    opacity: 1;\n    visibility: visible;\n    pointer-events: auto;\n    transform: translateY(0);\n    transition: opacity 0.55s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.55s cubic-bezier(0.2, 0.8, 0.2, 1);\n  }\n\n  &__eyebrow {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    font-size: 12px;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: var(--v2-muted-2);\n    font-weight: 500;\n\n    b {\n      font-family: 'Playfair Display', serif;\n      font-size: 24px;\n      letter-spacing: 0;\n      text-transform: none;\n      color: var(--v2-red);\n      font-weight: 400;\n    }\n  }\n\n  h3 {\n    margin: 22px 0 18px;\n    font-size: clamp(40px, 5vw, 84px);\n    line-height: 1.02;\n    letter-spacing: -0.015em;\n    text-wrap: balance;\n  }\n\n  p {\n    margin: 0;\n    color: var(--v2-muted);\n    line-height: 1.55;\n    font-size: clamp(17px, 1.5vw, 22px);\n    max-width: 40ch;\n    text-wrap: pretty;\n  }\n}\n\n.v2-hiw-phone-panel {\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transform: translateY(60px) scale(0.96);\n  transition: opacity 0.65s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.65s cubic-bezier(0.2, 0.8, 0.2, 1), visibility 0s linear 0.65s;\n  zoom: var(--phone-zoom, 1);\n\n  &[data-active='true'] {\n    opacity: 1;\n    visibility: visible;\n    pointer-events: auto;\n    transform: translateY(0) scale(1);\n    transition: opacity 0.65s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.65s cubic-bezier(0.2, 0.8, 0.2, 1);\n  }\n}\n\n@media (max-width: 820px) {\n  .v2-hiw-content {\n    grid-template-columns: minmax(0, 1fr) !important;\n    grid-template-rows: auto minmax(0, 1fr);\n    gap: 20px !important;\n    padding-top: 18px !important;\n  }\n  .v2-hiw-stage {\n    padding: 92px 20px 20px !important;\n  }\n  .v2-hiw-copy-column,\n  .v2-hiw-phone-column {\n    transform: none !important;\n  }\n  .v2-hiw-copy-panel h3 {\n    font-size: 32px !important;\n    margin: 12px 0 !important;\n    line-height: 1.06 !important;\n  }\n  .v2-hiw-copy-panel p {\n    font-size: 16px !important;\n    line-height: 1.45 !important;\n  }\n  .v2-hiw-copy-panel__eyebrow {\n    font-size: 10px !important;\n  }\n  .v2-hiw-phone-column {\n    padding: 16px 0 !important;\n  }\n  .v2-hiw-stage__head {\n    padding-bottom: 16px !important;\n    gap: 12px !important;\n  }\n  .v2-hiw-stage__head h2 {\n    font-size: 30px !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .v2-hiw-stage__head p {\n    margin-bottom: 6px !important;\n  }\n  .v2-hiw-stage__head h2 {\n    font-size: 28px !important;\n  }\n}\n\n@media (max-height: 700px) and (max-width: 820px) {\n  .v2-hiw-copy-panel h3 {\n    font-size: 27px !important;\n    margin: 8px 0 !important;\n  }\n  .v2-hiw-copy-panel p {\n    font-size: 14px !important;\n  }\n  .v2-hiw-stage__head h2 {\n    font-size: 24px !important;\n  }\n  .v2-hiw-content {\n    gap: 12px !important;\n  }\n  .v2-hiw-stage {\n    padding-top: 86px !important;\n  }\n  .v2-hiw-stage__head {\n    padding-bottom: 10px !important;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Phone mockup frame\n// ---------------------------------------------------------------------------\n// Full phone: the screen uses the app screenshots' 1206x2622 ratio so they fit without cropping\n// (236px wide -> ~495px tall; keep PHONE_WIDTH/PHONE_HEIGHT in useHowItWorksScroll in sync).\n.v2-phone {\n  position: relative;\n  width: 236px;\n  background: #050505;\n  border-radius: 36px;\n  padding: 8px;\n  box-shadow: 0 40px 60px -30px rgba(0, 0, 0, 0.9), 0 0 0 1px #2a2a26;\n  box-sizing: border-box;\n\n  &__screen {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 1206 / 2622;\n    background: #0f1512;\n    border-radius: 29px;\n    overflow: hidden;\n  }\n}\n\n// --- Screenshots ---------------------------------------------------------\n.v2-phone__screenshot {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n// --- Map pulses over screenshots -----------------------------------------\n// Mirrors the app's venue beams (ivy-app CheckedInVenueMapCircles): three staggered waves per\n// venue, each growing 1x -> 1.75x with easeOutCubic over 3s while fading out.\n.v2-map-pulses {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.v2-map-pulse {\n  position: absolute;\n  width: 20%;\n  aspect-ratio: 1;\n  transform: translate(-50%, -50%);\n\n  // check-in: brand red #AA0100 at full intensity\n  --pulse-fill: rgba(170, 1, 0, 0.42);\n  --pulse-stroke: rgba(170, 1, 0, 0.85);\n\n  // partnered hotspot: sponsored orange #FF5900\n  &--hotspot {\n    --pulse-fill: rgba(255, 89, 0, 0.4);\n    --pulse-stroke: rgba(255, 89, 0, 0.85);\n  }\n\n  > span {\n    position: absolute;\n    inset: 0;\n    border-radius: 50%;\n    background: var(--pulse-fill);\n    border: 2px solid var(--pulse-stroke);\n    box-sizing: border-box;\n    animation: v2MapPulse 3s cubic-bezier(0.33, 1, 0.68, 1) infinite both;\n\n    &:nth-child(2) {\n      animation-delay: -1s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: -2s;\n    }\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    > span:not(:first-child) {\n      display: none;\n    }\n  }\n}\n\n@keyframes v2MapPulse {\n  from {\n    opacity: 1;\n    transform: scale(1);\n  }\n  to {\n    opacity: 0;\n    transform: scale(1.75);\n  }\n}\n\n// --- Live chat (step 3) ----------------------------------------------------\n// The app's chat screen at 1/3 of the 660px screenshot it replaces (screen is\n// 220 x 478 before --phone-zoom), so it plays like live messaging.\n.v2-chat {\n  --chat-bg: #101c1c;\n  --chat-me: #34433e;\n  --chat-them: #faefdb;\n  --chat-cream: #f6ead6;\n\n  display: flex;\n  flex-direction: column;\n  background: var(--chat-bg);\n  font-family: 'Inter', 'Outfit', sans-serif;\n  color: var(--chat-cream);\n\n  &__status {\n    position: relative;\n    height: 30px;\n    flex: none;\n    font-size: 9.5px;\n    font-weight: 600;\n    padding: 12px 0 0 24px;\n    box-sizing: border-box;\n  }\n\n  &__island {\n    position: absolute;\n    top: 8px;\n    left: 50%;\n    width: 68px;\n    height: 20px;\n    margin-left: -34px;\n    border-radius: 12px;\n    background: #000;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    height: 36px;\n    flex: none;\n    padding: 0 10px 0 10px;\n\n    svg {\n      width: 14px;\n      height: 14px;\n      fill: none;\n      stroke: var(--chat-cream);\n      stroke-width: 2;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  }\n\n  &__name {\n    flex: 1;\n    font-size: 12.5px;\n    font-weight: 700;\n  }\n\n  &__more {\n    display: flex;\n    flex-direction: column;\n    gap: 1.6px;\n\n    i {\n      width: 2.6px;\n      height: 2.6px;\n      border-radius: 50%;\n      background: var(--chat-cream);\n    }\n  }\n\n  &__thread {\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 4px 9px 10px;\n  }\n\n  &__date {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin: 2px 0 6px;\n    font-size: 6.5px;\n\n    &::before,\n    &::after {\n      content: '';\n      flex: 1;\n      height: 0.5px;\n      background: #3a4443;\n    }\n\n    span {\n      padding: 3px 7px;\n      border: 0.5px solid #3a4443;\n      border-radius: 10px;\n    }\n  }\n\n  &__row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    animation: v2ChatIn 0.28s cubic-bezier(0.2, 0.8, 0.2, 1) both;\n\n    &--me {\n      justify-content: flex-end;\n    }\n  }\n\n  &__avatar {\n    width: 34px;\n    height: 34px;\n    flex: none;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n\n  &__bubble {\n    max-width: 72%;\n    padding: 6px 7px 5px;\n    border-radius: 6px;\n    font-size: 8.7px;\n    line-height: 1.3;\n    overflow-wrap: anywhere;\n\n    small {\n      display: block;\n      margin-top: 2px;\n      font-size: 5.5px;\n      opacity: 0.6;\n    }\n\n    &--me {\n      background: var(--chat-me);\n      color: var(--chat-cream);\n    }\n\n    &--them {\n      background: var(--chat-them);\n      color: #1c1c1c;\n    }\n  }\n\n  &__typing {\n    display: flex;\n    gap: 3px;\n    padding: 9px 9px;\n\n    i {\n      width: 4px;\n      height: 4px;\n      border-radius: 50%;\n      background: #6b6355;\n      animation: v2ChatDot 1s ease-in-out infinite;\n\n      &:nth-child(2) {\n        animation-delay: 0.15s;\n      }\n\n      &:nth-child(3) {\n        animation-delay: 0.3s;\n      }\n    }\n  }\n\n  &__composer {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    flex: none;\n    padding: 0 9px 18px;\n  }\n\n  &__input {\n    flex: 1;\n    min-height: 30px;\n    display: flex;\n    align-items: center;\n    padding: 4px 9px;\n    box-sizing: border-box;\n    border-radius: 6px;\n    background: var(--chat-me);\n    font-size: 7.5px;\n    line-height: 1.3;\n    color: #aab3b0;\n\n    &[data-typing='true'] {\n      color: var(--chat-cream);\n\n      &::after {\n        content: '';\n        width: 0.8px;\n        height: 9px;\n        margin-left: 1px;\n        background: var(--chat-cream);\n        animation: v2ChatCaret 0.9s steps(1) infinite;\n      }\n    }\n  }\n\n  &__send {\n    width: 16px;\n    height: 16px;\n    flex: none;\n    fill: #fff;\n  }\n}\n\n@keyframes v2ChatIn {\n  from {\n    opacity: 0;\n    transform: translateY(6px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes v2ChatDot {\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.45;\n  }\n  30% {\n    transform: translateY(-2.5px);\n    opacity: 1;\n  }\n}\n\n@keyframes v2ChatCaret {\n  50% {\n    opacity: 0;\n  }\n}\n\n// --- Story animation keyframes -------------------------------------------\n@keyframes v2StoryReveal {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Generic sections\n// ---------------------------------------------------------------------------\n.v2-section {\n  border-top: 1px solid var(--v2-border);\n  padding: 72px 0;\n\n  &--dotted {\n    background: var(--v2-bg) radial-gradient(rgba(244, 239, 230, 0.09) 1px, transparent 1.2px) 0 0 / 56px 56px;\n  }\n\n  &--light {\n    background: var(--v2-cream);\n    color: #0b0b0c;\n  }\n\n  &--trust {\n    background: var(--v2-bg-alt) radial-gradient(60% 50% at 50% 0%, rgba(63, 138, 96, 0.14), transparent 70%);\n  }\n\n  &--chicago {\n    padding-bottom: 72px;\n  }\n}\n\n// --- For singles -----------------------------------------------------\n.v2-singles-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));\n  gap: 48px 80px;\n  align-items: center;\n}\n\n.v2-singles-copy {\n  font-size: clamp(19px, 1.75vw, 27px);\n  color: var(--v2-muted);\n  max-width: 64ch;\n\n  h3 {\n    font-size: clamp(36px, 3.9vw, 62px);\n    line-height: 1.15;\n    margin: 0 0 20px;\n    letter-spacing: -0.01em;\n    color: var(--v2-cream);\n    text-wrap: balance;\n\n    &:not(:first-child) {\n      margin-top: 40px;\n    }\n  }\n\n  p {\n    margin: 0 0 18px;\n    text-wrap: pretty;\n  }\n}\n\n.v2-singles-testimonials {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.v2-testimonial {\n  margin: 0;\n  background: rgba(20, 20, 22, 0.85);\n  border: 1px solid var(--v2-border);\n  border-radius: 22px;\n  padding: 36px 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  backdrop-filter: blur(6px);\n  opacity: 0;\n  transform: translateY(16px);\n  transition: opacity 0.6s ease, transform 0.6s ease;\n\n  .v2-reveal.is-visible & {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  figcaption {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    font-size: 17px;\n    color: var(--v2-cream);\n    font-weight: 400;\n  }\n\n  &__stars {\n    display: flex;\n    gap: 3px;\n  }\n\n  blockquote {\n    margin: 0;\n    font-family: 'Playfair Display', serif;\n    font-style: italic;\n    font-size: clamp(22px, 1.9vw, 29px);\n    line-height: 1.4;\n    font-weight: 400;\n    text-wrap: pretty;\n  }\n}\n\n// --- For venues --------------------------------------------------------\n.v2-venues-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 340px), 1fr));\n  gap: 48px 80px;\n  align-items: center;\n  margin-bottom: 72px;\n\n  &--reverse {\n    margin-bottom: 0;\n  }\n\n  h3 {\n    font-size: clamp(38px, 4.1vw, 66px);\n    line-height: 1.1;\n    margin: 0 0 26px;\n    letter-spacing: -0.01em;\n    color: var(--v2-green);\n  }\n\n  p {\n    margin: 0 0 18px;\n    font-size: clamp(19px, 1.75vw, 27px);\n    color: #4a463f;\n    max-width: 60ch;\n    text-wrap: pretty;\n  }\n}\n\n.v2-venue-photo {\n  margin: 0;\n\n  img {\n    display: block;\n    width: 100%;\n    aspect-ratio: 4 / 3;\n    object-fit: cover;\n    border-radius: 18px;\n  }\n}\n\n.v2-checklist {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  li {\n    display: flex;\n    gap: 16px;\n    align-items: flex-start;\n    font-size: clamp(19px, 1.75vw, 27px);\n    color: var(--v2-cream);\n    line-height: 1.5;\n\n    svg {\n      flex-shrink: 0;\n      transform: translateY(4px);\n    }\n  }\n\n  // Used on the light \"For venues\" section, where the surrounding text is dark.\n  &--dark li {\n    color: #0b0b0c;\n  }\n}\n\n// --- Trust ---------------------------------------------------------------\n.v2-trust-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));\n  gap: 48px 80px;\n  align-items: center;\n\n  h3 {\n    font-size: clamp(36px, 3.9vw, 62px);\n    line-height: 1.15;\n    margin: 0 0 28px;\n    letter-spacing: -0.01em;\n    color: var(--v2-cream);\n    text-wrap: balance;\n  }\n}\n\n.v2-trust-copy {\n  font-size: clamp(19px, 1.75vw, 27px);\n  color: var(--v2-muted);\n  max-width: 64ch;\n\n  p {\n    margin: 0 0 18px;\n    text-wrap: pretty;\n  }\n}\n\n// --- Around Chicago --------------------------------------------------\n.v2-chicago-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 24px;\n  flex-wrap: wrap;\n  padding-bottom: 40px;\n\n  h2 {\n    margin: 0;\n  }\n}\n\n.v2-chicago-blurb {\n  margin: 0;\n  color: var(--v2-muted);\n  font-size: clamp(17px, 1.4vw, 21px);\n  max-width: 40ch;\n  text-wrap: pretty;\n}\n\n.v2-chicago-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n\n  @media (max-width: 1023px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.v2-venue-card {\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  background: var(--v2-bg-alt);\n  border: 1px solid var(--v2-border);\n  border-radius: 20px;\n  padding: 26px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-height: 190px;\n  opacity: 0;\n  transform: translateY(16px);\n  transition: opacity 0.6s ease, transform 0.6s ease, border-color 0.2s ease;\n\n  .v2-reveal.is-visible & {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  &:hover {\n    border-color: rgba(111, 168, 134, 0.4);\n  }\n\n  // Keeps the name/type readable over the logo.\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background: linear-gradient(to top, var(--v2-bg-alt) 18%, rgba(20, 20, 22, 0.55) 55%, rgba(20, 20, 22, 0.15) 100%);\n    pointer-events: none;\n  }\n\n  &:hover &__logo {\n    opacity: 0.3;\n    transform: scale(1.04);\n  }\n\n  &--placeholder {\n    background: linear-gradient(100deg, var(--v2-bg-alt) 40%, #1c1c1f 50%, var(--v2-bg-alt) 60%) 0 0 / 300% 100%;\n    animation: v2VenueShimmer 1.6s linear infinite;\n  }\n\n  // Faded venue logo (or venue-type icon) filling the card background, toned to the cream palette.\n  // The radial mask softens the edges so rectangular logos (white/solid backgrounds) don't show a hard box.\n  &__logo {\n    position: absolute;\n    z-index: -2;\n    inset: 6% 10%;\n    width: 80%;\n    height: 88%;\n    object-fit: contain;\n    opacity: 0.2;\n    filter: grayscale(1) sepia(0.3) brightness(1.15);\n    pointer-events: none;\n    -webkit-mask-image: radial-gradient(closest-side, #000 60%, transparent 100%);\n    mask-image: radial-gradient(closest-side, #000 60%, transparent 100%);\n    transition: opacity 0.3s ease, transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1);\n  }\n\n  &__top {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-height: 16px;\n  }\n\n  &__stat {\n    font-size: 12px;\n    letter-spacing: 0.04em;\n    color: var(--v2-green-light);\n    font-weight: 500;\n  }\n\n  &__pulse {\n    flex-shrink: 0;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: var(--v2-green-check);\n    animation: v2VenuePulse 2.4s ease-out infinite;\n  }\n\n  &__body {\n    margin-top: auto;\n  }\n\n  &__name {\n    margin: 0 0 4px;\n    font-family: 'Playfair Display', serif;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 1.2;\n  }\n\n  &__area {\n    margin: 0;\n    font-size: 12.5px;\n    color: var(--v2-muted);\n    letter-spacing: 0.04em;\n  }\n}\n\n@keyframes v2VenueShimmer {\n  to {\n    background-position: -300% 0;\n  }\n}\n\n@keyframes v2VenuePulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(63, 138, 96, 0.5);\n  }\n  60% {\n    box-shadow: 0 0 0 7px rgba(63, 138, 96, 0);\n  }\n}\n\n@media (max-width: 767px) {\n  .v2-chicago-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n  .v2-venue-card {\n    padding: 20px 14px !important;\n  }\n}\n\n// --- About ---------------------------------------------------------------\n.v2-about {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 96px clamp(24px, 5vw, 96px);\n  text-align: center;\n  box-sizing: border-box;\n\n  &__title {\n    font-style: italic;\n    font-size: clamp(48px, 7vw, 104px);\n    line-height: 1.02;\n    margin: 0 0 32px;\n    letter-spacing: -0.015em;\n    text-wrap: balance;\n  }\n\n  &__body {\n    margin: 0 auto;\n    color: var(--v2-muted);\n    font-size: clamp(18px, 1.6vw, 24px);\n    max-width: 60ch;\n    text-wrap: pretty;\n  }\n}\n\n// --- Download --------------------------------------------------------\n.v2-download {\n  border-top: 1px solid var(--v2-border);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 96px clamp(24px, 5vw, 96px);\n  text-align: center;\n  box-sizing: border-box;\n\n  &__title {\n    font-size: clamp(44px, 6vw, 88px);\n    line-height: 1.05;\n    margin: 0 0 18px;\n    letter-spacing: -0.015em;\n\n    em {\n      color: var(--v2-red);\n    }\n  }\n\n  &__subtitle {\n    margin: 0 0 40px;\n    color: var(--v2-muted);\n    font-size: 18px;\n  }\n\n  &__cta-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 22px;\n    flex-wrap: wrap;\n    margin-bottom: 24px;\n  }\n\n  &__qr {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n\n    span {\n      font-size: 13px;\n      color: var(--v2-muted);\n      text-align: center;\n      line-height: 1.4;\n    }\n  }\n\n  &__stores {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    flex-wrap: wrap;\n\n    a {\n      border: 1px solid rgba(244, 239, 230, 0.22);\n      border-radius: 999px;\n      padding: 9px 18px;\n      font-size: 13.5px;\n      color: var(--v2-muted);\n      transition: border-color 0.2s ease;\n\n      &:hover {\n        border-color: rgba(244, 239, 230, 0.5);\n      }\n    }\n  }\n\n  &__disclaimer {\n    margin: 26px 0 0;\n    font-size: 13.5px;\n    color: var(--v2-muted);\n    opacity: 0.85;\n  }\n}\n\n@media (max-width: 767px) {\n  .v2-download__qr {\n    display: none;\n  }\n}\n\n// --- Footer ------------------------------------------------------------\n.v2-footer {\n  border-top: 1px solid var(--v2-border);\n  padding: 56px 24px 44px;\n\n  &__row {\n    max-width: 1240px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    gap: 40px;\n    flex-wrap: wrap;\n\n    > div:first-child {\n      .v2-logo {\n        margin-bottom: 18px;\n      }\n\n      p {\n        margin: 0 0 6px;\n        font-size: 14px;\n        color: var(--v2-muted);\n\n        a {\n          color: var(--v2-muted);\n        }\n      }\n    }\n  }\n\n  &__links {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    font-size: 14px;\n\n    span {\n      color: var(--v2-muted);\n    }\n  }\n\n  &__legal-link {\n    text-decoration: underline;\n    text-underline-offset: 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
